export default class CreateSpecOutRequest {
    ownerId = '';
    branchId = '';
    deskId: string = null;
    emailTemplateId = '';
    emailBccUser = true;
    isTest = false;
    testEmailAddresses = '';
    workerId = '';
}
